<template>
  <div class="ui-resend-code">
    <UIButton
      v-if="isResendAvailable"
      :label="resendLabel"
      type="button"
      variant="secondary"
      fill="outlined"
      class="ui-resend-code__button"
      :loading
      :disabled="loading"
      @click="emit('click')"
    />
    <template v-else-if="time !== undefined">
      <div class="ui-resend-code__title">{{ title }}</div>
      <div class="ui-resend-code__subtitle">{{ timeLabel }}: {{ displayTime }}</div>
    </template>
  </div>
</template>

<script setup lang="ts">
import { computed, ref, watch } from 'vue'
import { useIntervalFn } from '@vueuse/core'

import { getTimeDiff } from './utils/helpers'

import { UIButton } from '@ui/buttons'

type Props = {
  title?: string
  timeLabel?: string
  resendLabel?: string
  lastSendTime: number
  delay: number
  loading?: boolean
}

type Emits = {
  click: []
}

const { title = 'Didn\'t receive the code?', timeLabel = 'You can resend it in', resendLabel = 'Resend code', ...props } = defineProps<Props>()
const emit = defineEmits<Emits>()

const time = ref<number | undefined>(undefined)

const { pause, resume } = useIntervalFn(() => {
  updateTime()
  if (isResendAvailable.value) {
    pause()
  }
}, 1000)

const displayTime = computed(() => `${time.value} second${time.value === 1 ? '' : 's'}`)

const isResendAvailable = computed(() => time.value !== undefined && time.value <= 0)

const updateTime = () => {
  time.value = getTimeDiff(props.lastSendTime, props.delay)
}

watch(() => props.lastSendTime, () => {
  updateTime()
  resume()
}, { immediate: true })
</script>

<style>
.ui-resend-code {
  @apply text-sm sm:text-xs text-center;

  &__button {
    @apply w-full;
  }
}
</style>
